/**
 * Canonical Terms & Conditions copy.
 * Imported by `TermsAndConditions.jsx` and `signupLegalDocuments.js` (Sign-up modal).
 */
export const TERMS_AND_CONDITIONS_SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    body: "By accessing or using AlphaSniper Trading services, you agree to be bound by these Terms and Conditions. If you do not agree, do not use our services.",
  },
  {
    title: "2. Service Description",
    body: "AlphaSniper Trading provides auto-copy trading infrastructure, onboarding support, and related educational/operational content. Any examples, metrics, or strategy descriptions are provided for informational purposes and do not constitute guaranteed outcomes.",
  },
  {
    title: "3. Membership and Access",
    body: "Access is granted after successful onboarding and payment where applicable. Access rights are personal, non-transferable, and may be restricted or revoked in case of abuse, unauthorized sharing, or policy violations.",
  },
  {
    title: "4. Trading Risk Disclosure",
    body: "Trading leveraged instruments involves substantial risk and may not be suitable for all users. You are solely responsible for your risk settings, account management, and all trading decisions. Past performance is not indicative of future results.",
  },
  {
    title: "5. User Responsibilities",
    body: "You agree to provide accurate information, maintain account security, use the service lawfully, avoid unauthorized redistribution of protected content, and refrain from fraudulent, abusive, or manipulative behavior.",
  },
  {
    title: "6. Payment Terms",
    body: "Where paid services are offered, fees, billing periods, and promotional conditions are displayed at checkout. Payment must be completed before paid access is activated. Transaction processing may involve third-party providers.",
  },
  {
    title: "7. Intellectual Property",
    body: "All AlphaSniper Trading branding, materials, systems, and content are protected by applicable intellectual property laws. Unauthorized copying, resale, redistribution, or publication is prohibited.",
  },
  {
    title: "8. Limitation of Liability",
    body: "AlphaSniper Trading is not liable for trading losses, missed opportunities, broker-side issues, market events, technical outages, latency differences, or indirect/consequential damages. To the extent permitted by law, liability is limited to amounts paid for the applicable service period.",
  },
  {
    title: "9. Service Changes",
    body: "We may update, modify, suspend, or discontinue features, pricing, onboarding rules, and service components at any time, including for security, legal, or operational reasons.",
  },
  {
    title: "10. Refund Policy",
    body: "Refund requests are reviewed according to the active offer terms shown at purchase and our published Refund Policy. Where a first-month satisfaction guarantee applies, eligibility requires compliance with all stated conditions, including—when specified for that offer—registration, funding, and trading through an AlphaSniper-designated broker partner account using the official partner links and onboarding instructions we provide. Accounts outside that designated partner programme are not eligible for that guarantee. Market losses alone are not, by themselves, grounds for refund outside the express guarantee rules.",
  },
  {
    title: "11. Governing Law and Disputes",
    body: "These terms are governed by applicable law. Any dispute related to these terms or service usage will be handled through the appropriate legal channels under the relevant jurisdiction.",
  },
  {
    title: "12. Contact",
    body: "For questions related to these Terms and Conditions, contact AlphaSniper Trading through the official support channels listed on our website.",
  },
];
